import React, { useState } from 'react';
import { translations } from '../translations';
import apiService from '../services/apiService';

function Login({ onLogin, language = 'en' }) {
  const [patientId, setPatientId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const t = translations[language] || translations.en;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Simple validation
    if (!patientId.trim()) {
      setError(t.login.errors.patientIdRequired);
      setIsLoading(false);
      return;
    }

    if (!password.trim()) {
      setError(t.login.errors.passwordRequired);
      setIsLoading(false);
      return;
    }

    try {
      // Authentification via l'API
      const response = await apiService.patientLogin(patientId, password);
      
      if (response.success) {
        // Stocker les tokens et les informations utilisateur
        localStorage.setItem('token', response.accessToken);
        localStorage.setItem('refreshToken', response.refreshToken);
        localStorage.setItem('user', JSON.stringify(response.user));
        
        // Appeler la fonction de connexion avec les données de l'API
        onLogin(response.user);
      } else {
        setError(response.message || t.login.errors.invalidCredentials);
      }
    } catch (error) {
      console.error('Erreur de connexion:', error);
      setError(error.message || t.login.errors.invalidCredentials);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1 className="study-title">FAST-TRACK HIP</h1>
          <div className="login-logo">
            <img src="/images/logo_charite.svg" alt="Charité Logo" className="logo-charite" />
            <span className="logo-separator">×</span>
            <img src="/images/logo_bw.svg" alt="BW Logo" className="logo-bw" />
          </div>
          <p className="login-subtitle">{t.login.subtitle}</p>
        </div>
        
        {error && (
          <div className="error">
            <span>⚠️</span>
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="login-form-fields">
            <div className="form-group">
              <label htmlFor="patientId">{t.login.patientId}</label>
              <input
                type="text"
                id="patientId"
                value={patientId}
                onChange={(e) => setPatientId(e.target.value)}
                placeholder={t.login.patientIdPlaceholder}
                disabled={isLoading}
                autoComplete="off"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">{t.login.password}</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t.login.passwordPlaceholder}
                disabled={isLoading}
                autoComplete="off"
              />
            </div>
            
            <button 
              type="submit" 
              className="btn" 
              disabled={isLoading}
            >
              {isLoading ? t.login.signingIn : t.login.signIn}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login; 